import React from "react";
import { node, number, oneOf, string } from "prop-types";
import isEmpty from "lodash/isEmpty";
import CustomData from "pages/_components/CustomData/CustomData";

export const EcheqTransactionInfo = ({ field, fieldString, i18nId, value, children }) => {
    if (!value && !i18nId && isEmpty(children)) {
        return null;
    }

    return (
        <CustomData
            titleText={fieldString || field}
            titleTextType={fieldString ? "TEXT" : "I18N"}
            valueText={i18nId || value || children}
            valueTextType={i18nId ? "I18N" : "TEXT"}
        />
    );
};

EcheqTransactionInfo.propTypes = {
    field: string.isRequired,
    fieldString: string,
    i18nId: string,
    value: oneOf([string, number]),
    children: node,
};

EcheqTransactionInfo.defaultProps = {
    fieldString: null,
    i18nId: "",
    value: "",
    children: null,
};
export default EcheqTransactionInfo;
